import { render, staticRenderFns } from "./stockLog.vue?vue&type=template&id=38c64310&scoped=true&"
import script from "./stockLog.vue?vue&type=script&lang=js&"
export * from "./stockLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c64310",
  null
  
)

export default component.exports